export default __webpack_public_path__ + "static/media/gallery_06.44e66a68.jpg";